/* tslint:disable */
/* eslint-disable */
/**
 * EH Commissioning WebAPI 1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ChecklistItemHeader,
  ChecklistItemHeaderFromJSON,
  ChecklistItemHeaderFromJSONTyped,
  ChecklistItemHeaderToJSON,
} from "./ChecklistItemHeader";
import { ErrorResponse, ErrorResponseFromJSON, ErrorResponseFromJSONTyped, ErrorResponseToJSON } from "./ErrorResponse";

/**
 *
 * @export
 * @interface ChecklistItemHeaderControllerResponse
 */
export interface ChecklistItemHeaderControllerResponse {
  /**
   *
   * @type {ChecklistItemHeader}
   * @memberof ChecklistItemHeaderControllerResponse
   */
  data?: ChecklistItemHeader;
  /**
   *
   * @type {ErrorResponse}
   * @memberof ChecklistItemHeaderControllerResponse
   */
  error?: ErrorResponse;
}

export function ChecklistItemHeaderControllerResponseFromJSON(json: any): ChecklistItemHeaderControllerResponse {
  return ChecklistItemHeaderControllerResponseFromJSONTyped(json, false);
}

export function ChecklistItemHeaderControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChecklistItemHeaderControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data") ? undefined : ChecklistItemHeaderFromJSON(json["data"]),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function ChecklistItemHeaderControllerResponseToJSON(value?: ChecklistItemHeaderControllerResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: ChecklistItemHeaderToJSON(value.data),
    error: ErrorResponseToJSON(value.error),
  };
}
